<template>
  <div>
    <div id="popupBackground">
      <div @click="onDialogClose" id="triggerClick" aria-hidden="true"></div>
      <vx-card
        ref="dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Video player"
        id="videoPopup"
      >
        <div tabindex="0" data-focus-sentinel @focus="focusLastInDialog"></div>
        <button
          type="button"
          class="no-style close-icon-button"
          :aria-label="'Close ' + 'video player'"
          @click="onDialogClose"
        >
          <span class="ml-4 feather-icon select-none close-icon" aria-hidden="true"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line></svg
          ></span>
        </button>
        <div id="player-overlay">
          <!-- No `crossorigin` here on purpose - see mixins/captionedVideo.js. -->
          <video id="video-file-player" :autoplay="1" :controls="true">
            <source :src="videoURL" type="video/mp4" />
            <!-- Captions (SC 1.2.2): the .vtt beside the MP4, or one passed in. -->
            <track
              v-if="captionsUrl"
              kind="captions"
              label="English"
              srclang="en"
              :src="captionsUrl"
              default
              @load="onCaptionsLoad"
              @error="onCaptionsError"
            />
          </video>
        </div>
        <details v-if="transcript || transcriptText" class="video-transcript mt-3">
          <summary>Video transcript</summary>
          <div v-if="transcript" class="mt-2" v-html="transcript"></div>
          <p v-else class="mt-2">{{ transcriptText }}</p>
        </details>

        <div tabindex="0" data-focus-sentinel @focus="focusFirstInDialog"></div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import dialogMixin from '@/mixins/dialog';
import captionedVideo from '@/mixins/captionedVideo';

export default {
  mixins: [dialogMixin, captionedVideo],
  computed: {
    videoCode() {
      return this.$store.getters.experiencePopupVideoUrl;
    },
    // Inputs for the captionedVideo mixin.
    videoSourceUrl() {
      return this.videoURL;
    },
    explicitCaptions() {
      return this.captions;
    },
    explicitTranscript() {
      return this.transcript;
    },
  },
  props: {
    videoURL: { type: String, required: true },
    // Optional overrides; by default the .vtt beside the MP4 is used for both (see
    // mixins/captionedVideo.js).
    captions: { type: String, default: '' },
    transcript: { type: String, default: '' },
  },
  inject: ['closePopup'],
  methods: {
    onDialogClose() {
      this.closePopup();
    },
  },
};
</script>
<style scoped>
#videoPopup {
  position: fixed;
  top: 10%;
  width: 50%;
  left: 25%;
}
#player-overlay {
  padding: 0 10%;
}

video {
  display: block;
  width: 100%;
  height: 100%;
}
#popupBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
#popupBackground #triggerClick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.close-icon {
  width: 15px;
  float: right;
  margin-bottom: 5px;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  #videoPopup {
    top: 10%;
    width: 94%;
    left: 3%;
  }
}
</style>
